import React from 'react';
import Section from './Section';
import styles from './InformationSection.scss';

const InformationSection = ({ children }) => (
	<Section className="p-spacer d-flex justify-content-between align-items-center">
		{children}
	</Section>
);

InformationSection.Label = ({ children }) => (
	<span className={styles.label}>
		{children}
		{':'}
	</span>
);
InformationSection.Value = ({ children }) => <span className={styles.value}>{children}</span>;

export default InformationSection;



// WEBPACK FOOTER //
// ./src/ui/components/InformationSection.js